import { ReactNode, useMemo, useState } from 'react';

import { Order } from 'store/Orders/types';
import { createCtx } from 'util/createCtx';
import { useDisclosure, UseDisclosureReturn } from 'util/hooks';

import type { Dispatch, SetStateAction } from 'react';
import type { TabBarKey } from 'store/App/constants';

export type MainScreen = 'chef' | 'overview';

const [useGridViewContext, GridViewContext] = createCtx<{
  hiddenItemDisclosure: UseDisclosureReturn;
  selectedOrder: { uuid: Order['uuid']; tab: TabBarKey | undefined } | null;
  setSelectedOrder: (
    uuid: { uuid: Order['uuid']; tab: TabBarKey | undefined } | null,
  ) => void;
  selectedOrderItemUuid: string | undefined;
  setSelectedOrderItemUuid: Dispatch<SetStateAction<string | undefined>>;
}>();

export function GridViewContextProvider({ children }: { children: ReactNode }) {
  const hiddenItemDisclosure = useDisclosure();
  const [selectedOrder, setSelectedOrder] = useState<{
    uuid: Order['uuid'];
    tab: TabBarKey | undefined;
  } | null>(null);
  const [selectedOrderItemUuid, setSelectedOrderItemUuid] = useState<
    string | undefined
  >(undefined);

  const screenProviderValue = useMemo(
    () => ({
      hiddenItemDisclosure,
      selectedOrder,
      setSelectedOrder,
      selectedOrderItemUuid,
      setSelectedOrderItemUuid,
    }),
    [hiddenItemDisclosure, selectedOrder, selectedOrderItemUuid],
  );

  return (
    <GridViewContext value={screenProviderValue}>{children}</GridViewContext>
  );
}

export { useGridViewContext };
